import MuiSlider from '@mui/material/Slider'
import { sliderStyles } from './Slider.styles'

interface SliderProps {
  zoom: number
  min?: number
  max?: number
  step?: number
  orientation?: 'horizontal' | 'vertical'
  onZoom: (zoom: number, transition: boolean) => void
}

function Slider({
  zoom,
  min = 0,
  max = 1,
  step = 0.01,
  orientation = 'horizontal',
  onZoom
}: SliderProps) {
  return (
    <MuiSlider
      sx={sliderStyles}
      orientation={orientation}
      value={zoom}
      min={min}
      max={max}
      step={step}
      onChange={(_event, value) => {
        onZoom(value as number, false)
      }}
      aria-label="Zoom"
    />
  )
}

export default Slider
